import {
  configureInitialDevices,
  getAvailableDevices
} from '../base/devices/actions';
import { getParticipantDisplayName } from '../base/participants/functions';
import { getBackendSafeRoomName } from '../base/util';
import { showNotification } from '../notifications/actions';
import {
  NOTIFICATION_TIMEOUT_TYPE,
  NOTIFICATION_TYPE
} from '../notifications/constants';
import logger from './logger';

/**
 * Notify that we've been kicked out of the conference.
 *
 * @param {JitsiParticipant} participant - The {@link JitsiParticipant}
 * instance which initiated the kick event.
 * @param {?Function} _ - Used only in native code.
 * @returns {Function}
 */
export function notifyKickedOut(participant) {
  return (dispatch, getState) => {
    if (!participant || participant?.isReplaced()) {
      return;
    }

    const args = {
      participantDisplayName: getParticipantDisplayName(
        getState,
        participant.getId()
      )
    };

    dispatch(
      showNotification(
        {
          appearance: NOTIFICATION_TYPE.ERROR,
          hideErrorSupportLink: true,
          descriptionKey: 'dialog.kickMessage',
          descriptionArguments: args,
          titleKey: 'dialog.kickTitle',
          titleArguments: args
        },
        NOTIFICATION_TIMEOUT_TYPE.STICKY
      )
    );
  };
}

/**
 * Setups initial devices. Makes sure we populate availableDevices list before configuring.
 *
 * @returns {Promise<any>}
 */
export function setupInitialDevices() {
  return async (dispatch) => {
    await dispatch(getAvailableDevices());
    await dispatch(configureInitialDevices());
  };
}

/**
 * Init.
 *
 * @returns {Promise<JitsiConnection>}
 */
export function init() {
  return (dispatch, getState) => {
    const room = getBackendSafeRoomName(
      getState()['features/base/conference'].room
    );

    // XXX For web based version we use conference initialization logic
    // from the old app (at the moment of writing).
    return dispatch(setupInitialDevices()).then(() =>
      // eslint-disable-next-line no-undef
      APP.conference
        .init({
          roomName: room
        })
        .catch((error) => {
          // eslint-disable-next-line no-undef
          APP.API.notifyConferenceLeft(APP.conference.roomName);
          logger.error(error);
        })
    );
  };
}
